// extracted by mini-css-extract-plugin
export default {"info":"OrgsFilterInfo_info__tdOj3","placeHolderShimmer":"OrgsFilterInfo_placeHolderShimmer__bxwNT"};